import { createSlice } from "@reduxjs/toolkit";
import {
  getNextQuestionThunk,
  getQuizPhaseThunk,
  getVideoTutorialInicioQuizThunk,
  sendAnswerThunk,
  startQuizThunk,
} from "./quiz.thunks";

const initialState = {
  sessionId: localStorage.getItem("quiz_session_id") || null,
  sessionData: null,

  currentQuestion: null,

  progreso: {
    actual: 0,
    total: 0,
    porcentaje: 0,
  },

  loading: false,
  error: null,

  completed: false,

  phase: null,

  videoTutorial: null,
  videoLoading: false,
};

const quizSlice = createSlice({
  name: "quiz",
  initialState,
  reducers: {
    resetQuizState: (state) => {
      localStorage.removeItem("quiz_session_id");

      state.sessionId = null;
      state.sessionData = null;
      state.currentQuestion = null;
      state.completed = false;
      state.error = null;
      state.loading = false;

      state.progreso = {
        actual: 0,
        total: 0,
        porcentaje: 0,
      };
    },
  },
  extraReducers: (builder) => {
    builder

      // START
      .addCase(startQuizThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(startQuizThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.sessionId = action.payload.id;
        state.sessionData = action.payload;
      })
      .addCase(startQuizThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // NEXT QUESTION
      .addCase(getNextQuestionThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getNextQuestionThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.currentQuestion = action.payload;

        state.progreso = {
          actual: action.payload.orden_actual,
          total: action.payload.total_preguntas,
          porcentaje: action.payload.progreso_porcentaje,
        };
      })
      .addCase(getNextQuestionThunk.rejected, (state, action) => {
        state.loading = false;

        if (action.payload === "QUIZ_COMPLETED") {
          state.completed = true;

          state.progreso = {
            ...state.progreso,
            porcentaje: 100,
            actual: state.progreso.total,
          };

          localStorage.removeItem("quiz_session_id");
        } else {
          state.error = action.payload;
        }
      })

      // SEND ANSWER
      .addCase(sendAnswerThunk.fulfilled, (state, action) => {
        const { progreso, evaluacion_completada } = action.payload.data;

        state.progreso = progreso;
        state.completed = evaluacion_completada;

        if (evaluacion_completada) {
          state.progreso = {
            ...state.progreso,
            porcentaje: 100,
            actual: state.progreso.total,
          };

          localStorage.removeItem("quiz_session_id");
        }
      })
      // GET PHASE
      .addCase(getQuizPhaseThunk.fulfilled, (state, action) => {
        state.phase = action.payload.fase_actual;

        if (action.payload.fase_actual === "en_progreso") {
          state.sessionId = action.payload.sesion_id;
          localStorage.setItem("quiz_session_id", action.payload.sesion_id);
        }
      })

      // GET VIDEO TUTORIAL INICIO QUIZ
      .addCase(getVideoTutorialInicioQuizThunk.pending, (state) => {
        state.videoLoading = true;
      })
      .addCase(getVideoTutorialInicioQuizThunk.fulfilled, (state, action) => {
        state.videoLoading = false;
        state.videoTutorial = action.payload;
      })
      .addCase(getVideoTutorialInicioQuizThunk.rejected, (state) => {
        state.videoLoading = false;
      });
  },
});

export const { resetQuizState } = quizSlice.actions;
export default quizSlice.reducer;
